import React from 'react';
import { Instagram, Facebook, MapPin, Phone, Mail } from 'lucide-react';
import { contactData } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12 mb-8">
          {/* Brand Column */}
          <div>
            <h3 className="font-serif text-2xl mb-4 text-white">
              Motherstore
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Votre boutique de vêtements féminins au cœur de Paris. Élégance, qualité et style parisien depuis notre boutique près de la Place de la Concorde.
            </p>
            <div className="flex space-x-4">
              <a
                href={contactData.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-rose-400 rounded-full flex items-center justify-center transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href={contactData.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-rose-400 rounded-full flex items-center justify-center transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="font-medium text-white uppercase tracking-wider text-sm mb-4">
              Contact
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-3 text-gray-400">
                <MapPin size={16} className="mt-1 flex-shrink-0 text-rose-400" />
                <span>
                  {contactData.address.street}<br />
                  {contactData.address.city}
                </span>
              </li>
              <li className="flex items-center space-x-3 text-gray-400">
                <Phone size={16} className="flex-shrink-0 text-rose-400" />
                <a 
                  href={`tel:${contactData.address.phone}`}
                  className="hover:text-rose-400 transition-colors duration-300"
                >
                  {contactData.address.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3 text-gray-400">
                <Mail size={16} className="flex-shrink-0 text-rose-400" />
                <a 
                  href={`mailto:${contactData.address.email}`}
                  className="hover:text-rose-400 transition-colors duration-300"
                >
                  {contactData.address.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Hours Column */}
          <div>
            <h4 className="font-medium text-white uppercase tracking-wider text-sm mb-4">
              Horaires
            </h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>{contactData.hours.weekdays}</li>
              <li>{contactData.hours.sunday}</li>
            </ul>
            <div className="mt-6">
              <h4 className="font-medium text-white uppercase tracking-wider text-sm mb-3">
                Navigation
              </h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <button
                    onClick={() => {
                      const element = document.getElementById('boutique');
                      if (element) element.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-gray-400 hover:text-rose-400 transition-colors duration-300"
                  >
                    Notre Boutique
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      const element = document.getElementById('collections');
                      if (element) element.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-gray-400 hover:text-rose-400 transition-colors duration-300"
                  >
                    Collections
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      const element = document.getElementById('contact');
                      if (element) element.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-gray-400 hover:text-rose-400 transition-colors duration-300"
                  >
                    Contact
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} Motherstore. Tous droits réservés. Fait avec passion à Paris.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
